import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { reduceList } from "../../common/list";
import { initialState } from "./initialState";
import { handleRequest } from "./retrieveListsRequested";
import { handleSuccess } from "./retrieveListsSucceeded";
import { handleFailure } from "./retrieveListsFailed";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const reduceState = resetState(
  initialState,
  createStateReducer(
    initialState,
    {
      [events.retrieveListsRequested]: handleRequest,
      [events.retrieveListsSucceeded]: handleSuccess,
      [events.retrieveListsFailed]: handleFailure,
    },
    (state = initialState, event) =>
      state.map((req) => ({
        ...req,
        lists: reduceList(req.lists, event),
      })),
  ),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
